import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Loader2, Star, MessageSquare, Send } from "lucide-react";
import api from "../lib/api";
import StarRating from "./StarRating";

export default function ReviewModal({ open, onClose, bookingId, targetUserId, targetUserName, onReviewed }) {
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const submit = async () => {
    if (rating === 0) return;
    setLoading(true);
    try {
      await api.post("/reviews", {
        target_user_id: targetUserId,
        booking_id: bookingId,
        rating,
        comment,
      });
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        setRating(0);
        setComment("");
        onReviewed?.();
        onClose();
      }, 1500);
    } catch (e) {
      alert(e.response?.data?.detail || "Erreur lors de l'envoi");
    } finally { setLoading(false); }
  };

  const ratingLabels = ["", "Mauvais", "Moyen", "Bien", "Tres bien", "Excellent"];

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-md" data-testid="review-modal">
        <DialogHeader>
          <DialogTitle className="text-[#0A2540]" style={{ fontFamily: 'Outfit' }}>
            {success ? "Merci pour votre avis !" : `Noter ${targetUserName || "l'utilisateur"}`}
          </DialogTitle>
        </DialogHeader>

        {success ? (
          <div className="text-center py-6">
            <div className="w-16 h-16 rounded-full bg-[#10B981]/10 flex items-center justify-center mx-auto mb-3">
              <Star className="w-8 h-8 text-[#FACC15] fill-[#FACC15]" />
            </div>
            <p className="text-sm text-[#64748B]">Votre avis a ete enregistre</p>
          </div>
        ) : (
          <div className="space-y-5">
            {/* Stars */}
            <div className="text-center">
              <p className="text-sm text-[#64748B] mb-3">Comment etait votre experience ?</p>
              <div className="flex justify-center">
                <StarRating rating={rating} onChange={setRating} size="w-10 h-10" interactive />
              </div>
              {rating > 0 && (
                <p className="text-sm font-medium text-[#0A2540] mt-2 animate-fade-in" style={{ fontFamily: 'Outfit' }}>
                  {ratingLabels[rating]}
                </p>
              )}
            </div>

            {/* Comment */}
            <div>
              <label className="text-xs font-medium text-[#64748B] flex items-center gap-1 mb-1.5">
                <MessageSquare className="w-3 h-3" /> Commentaire (optionnel)
              </label>
              <textarea
                value={comment}
                onChange={e => setComment(e.target.value)}
                placeholder="Partagez votre experience..."
                rows={3}
                className="w-full rounded-lg border border-[#CBD5E1] px-3 py-2 text-sm text-[#0A2540] placeholder:text-[#94A3B8] focus:outline-none focus:ring-2 focus:ring-[#0A2540]/20 resize-none"
                data-testid="review-comment"
              />
            </div>

            {/* Submit */}
            <Button
              onClick={submit}
              disabled={rating === 0 || loading}
              className="w-full bg-[#FACC15] text-[#0A2540] hover:bg-[#EAB308] font-semibold disabled:opacity-50"
              data-testid="submit-review-btn"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <Send className="w-4 h-4 mr-1" />}
              Envoyer mon avis
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
